import React from 'react'

function TechSelectHepas() {
  return (
    <embed src="\pdfs\E3.1.2_hepa_h14_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectHepas